import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { CommonModule } from '@angular/common';
import { MentionData } from '../../../shared/public-api';

@Component({
  selector: 'admin-mention',
  templateUrl: './mention.component.html',
  styleUrls: ['./mention.component.scss'],
  imports: [CommonModule],
})
export class MentionComponent extends BaseComponent<MentionData> implements OnInit {
  text = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.text = this.data.text;
  }
}
